import { Search, X } from "lucide-react";
import { useRef } from "react";
import Button from "./Button";
import FormField from "./FormField";

interface GeneralSearchProps {
    onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    searchFilters: any;
    setSearchFilters: (filters: any) => void;
    onClear?: () => void;
}

const GeneralSearch: React.FC<GeneralSearchProps> = ({ onSubmit, searchFilters, setSearchFilters, onClear }) => {
    const formRef = useRef<HTMLFormElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const handleClear = (e: React.MouseEvent) => {
        e.preventDefault();
        
        if (onClear) {
            // Use custom clear handler - let it update state
            onClear();
        } else {
            // Default behavior: clear the search term
            setSearchFilters({ ...searchFilters, generalSearchTerm: '' });
        }
        
        // Submit the form after state updates
        setTimeout(() => {
            const form = formRef.current || inputRef.current?.form;
            if (form) {
                form.requestSubmit();
            }
        }, 0);
    };

    const content = (
        <div className="flex items-center bg-white pl-3 ring-1 ring-gray-400 ring-offset-2 rounded-sm">
            <input
                ref={inputRef}
                id="generalSearchTerm"
                name="generalSearch"
                type="text"
                placeholder="Search..."
                className="focus:outline-none w-64"
                value={searchFilters.generalSearchTerm || ""}
                onChange={(e) => setSearchFilters({ ...searchFilters, generalSearchTerm: e.target.value })}
            />
            {searchFilters.generalSearchTerm && (
                <button
                    type="button"
                    onClick={handleClear}
                    className="text-gray-400 hover:text-gray-600 px-1"
                    aria-label="Clear search"
                >
                    <X size={18} />
                </button>
            )}
            <button
                type="submit"
                id="searchButton"
                name="searchButton"
                aria-label="Search"
                className="bg-primary py-1.5 pr-2 pl-2 text-white cursor-pointer rounded-sm"
            >
                <Search size={20}/>
            </button>
        </div>
    );

    if (onSubmit) {
        return (
            <form ref={formRef} className="w-full flex justify-end" onSubmit={onSubmit}>
                {content}
            </form>
        );
    }

    return <div className="w-full flex justify-end">{content}</div>;
}

export default GeneralSearch;
